import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectors as authSelectors } from '@hixme/auth-ui'

// hixme-ui
import Text from '@hixme-ui/text'
import Button from '@hixme-ui/button'

// module
import { resetUser } from '../actions'

import { getUserId, getUserName } from '../selectors'

const LoggedIn = ({ showLoggedInAs, username, reset }) => {
  if (showLoggedInAs) {
    return (
      <div
        style={{
          padding: '10px 30px',
          background: '#1c334f',
          color: '#F1F1F1',
          textAlign: 'center',
        }}
      >
        <Text thin fontSize="16px">
          You are logged in as {username}
        </Text>
        <Button
          mini
          onClick={reset}
          style={{
            marginLeft: '30px',
            background: '#BD0FE1',
            borderRadius: '20px',
            width: '150px',
          }}
        >
          Sign-out
        </Button>
      </div>
    )
  }

  return null
}

LoggedIn.displayName = 'LoggedIn'
LoggedIn.propTypes = {
  showLoggedInAs: PropTypes.bool.isRequired,
  username: PropTypes.string.isRequired,
  reset: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  const loggedInUser = authSelectors.getCredentials(state)
  const loggedInUserId = authSelectors.getUserId(state)
  const currentUserId = getUserId(state)
  const showLoggedInAs =
    loggedInUser.userRole === 'PlatformHixmeAdmin' && loggedInUserId !== currentUserId

  return {
    showLoggedInAs,
    username: getUserName(state),
  }
}

export default connect(
  mapStateToProps,
  {
    reset: resetUser,
  }
)(LoggedIn)
